import React, { Fragment, useEffect } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import PropTypes from 'prop-types';
import RippleButton from 'components/PartnerPage/RippleButton';
import RateCard from './RateCard';
import { useQuickQuoteContext } from 'contexts/QuickQuoteContext';
import RatesResultsSkeleton from './RatesResultsSkeleton';

const ResultsModal = ({ submitQuickQuote }) => {
  const {
    isModalOpen: isOpen, setIsModalOpen: onClose,
    shippingData, to, from, brand,
    loading: loadingRatesResults
  } = useQuickQuoteContext();

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const isOdd = shippingData?.rates?.length % 2 !== 0;

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-50 overflow-y-auto"
        onClose={() => onClose(false)}
      >
        <div className="min-h-screen px-4 text-center">
          <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-30" />
          </Transition.Child>


          <span
            className="inline-block h-screen align-middle"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >

            <div className="
              inline-block w-full max-w-4xl p-6 overflow-hidden text-left lg:w-3/4 pt-10
              align-middle transition-all transform bg-white shadow-xl rounded-2xl lg:px-12 lg:py-10
            ">
              <button
                onClick={() => onClose(false)}
                className="
                  absolute top-3 right-3 text-gray-700 hover:text-gray-900
                  focus:outline-none
                "
              >
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
              <h1 className="text-2xl font-bold text-gray-800 pb-10 text-center">
                {from.formatted_address} <span className="font-normal">to</span> {to.formatted_address}
              </h1>
              {loadingRatesResults ? (
                <RatesResultsSkeleton />
              ) : (shippingData?.international ? (
                <div className="grid md:grid-cols-2 gap-4 md:gap-5 lg:gap-8">
                  <RateCard rate={shippingData.rates[0].outbound} />
                  <RateCard rate={shippingData.rates[0].return} />
                </div>)
                : (
              <div className="grid md:grid-cols-2 gap-4 md:gap-5 lg:gap-8">
                {shippingData?.rates?.map((rate, index) => (
                  <RateCard
                    key={index}
                    rate={rate}
                    classNames={`col-span-1 ${
                      isOdd && index === shippingData.rates.length - 1 ?
                      'md:col-start-1 md:col-end-3 md:justify-self-center' : ''
                    }`}
                    brand={brand}
                  />
                ))}
              </div>
              ))}
              <div className="mt-4 text-center">
                <p className="text-lg py-5 text-gray-600 mt-4 text-center">
                  The Ship Date Does Not Count as a Day in Transit
                </p>
                <RippleButton
                  onClick={submitQuickQuote}
                  disabled={loadingRatesResults}
                  className={`
                    flex items-center justify-center bg-[#4FAB55] text-white rounded-full
                    py-2 px-6 h-[48px] w-3/4 max-w-56 mx-auto text-xl
                    ${loadingRatesResults ? 'opacity-50 cursor-not-allowed' : ''}
                  `}
                >
                  {loadingRatesResults ? 'Loading...' : 'Start Shipping'}
                </RippleButton>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

ResultsModal.propTypes = {
  submitQuickQuote: PropTypes.func,
};

export default ResultsModal;
